/* filterEditor.svelte.js generated by Svelte v5.56.9 */
import * as $ from 'svelte/internal/client';

export const filterEditor = $.tag_proxy($.proxy({ key: null, action: "open", nonce: 0 }), 'filterEditor');

let handledNonce = 0;

export function requestFilterEditor(key = null) {
	filterEditor.key = key;
	filterEditor.action = "open";
	filterEditor.nonce += 1;
}

/** Hide it again — what running a search does, so the results are what you look at next. */
export function dismissFilterEditor() {
	filterEditor.key = null;
	filterEditor.action = "close";
	filterEditor.nonce += 1;
}

/** The pending request, once, or null. Reading does not write reactive state, so no effect loops. */
export function takeFilterRequest() {
	if ($.strict_equals(filterEditor.nonce, handledNonce)) return null;

	handledNonce = filterEditor.nonce;

	return { key: filterEditor.key, action: filterEditor.action };
}